var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGraphs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M67.8 123.5H55.7V134.62H67.8V123.5Z",
    fill: "#E9AF34",
    stroke: "#E9AF34",
    strokeWidth: 0.499995,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M145.8 24.9999L141.5 74.7999C141.424 75.6313 141.025 76.3999 140.39 76.9417C139.755 77.4835 138.933 77.7556 138.1 77.6999L93.7 73.7999C93.2922 73.7623 92.8959 73.6444 92.5339 73.4528C92.1719 73.2612 91.8515 72.9998 91.5912 72.6836C91.3308 72.3675 91.1357 72.0029 91.0171 71.6109C90.8984 71.2189 90.8586 70.8073 90.9 70.3999L95.9 12.6999C95.9375 12.2921 96.0555 11.8957 96.2471 11.5338C96.4387 11.1718 96.7001 10.8514 97.0163 10.5911C97.3324 10.3307 97.697 10.1356 98.089 10.0169C98.481 9.89831 98.8926 9.85852 99.3 9.89988L136.3 13.0999L145.8 24.9999Z",
    fill: "#E9AF34",
    stroke: "#E9AF34",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.0001 21.3999C33.6383 21.3999 26.4421 23.5842 20.3225 27.6762C14.2028 31.7683 9.43489 37.584 6.62227 44.3873C3.80965 51.1905 3.07883 58.6753 4.52233 65.8941C5.96582 73.1129 9.51872 79.7411 14.7312 84.9397C19.9438 90.1382 26.5815 93.6732 33.8042 95.0973C41.0269 96.5213 48.5097 95.7704 55.3053 92.9394C62.1009 90.1085 67.9039 85.3249 71.9794 79.1943C76.0549 73.0636 78.2198 65.8616 78.2001 58.4999C78.1736 48.6512 74.2426 39.2149 67.2691 32.2602C60.2956 25.3054 50.8488 21.3999 41.0001 21.3999ZM41.0001 80.3999C36.6686 80.3999 32.4345 79.1155 28.8331 76.7091C25.2316 74.3027 22.4247 70.8824 20.7671 66.8807C19.1095 62.879 18.6758 58.4756 19.5209 54.2274C20.3659 49.9792 22.4516 46.077 25.5144 43.0143C28.5772 39.9515 32.4794 37.8657 36.7276 37.0207C40.9758 36.1757 45.3791 36.6094 49.3808 38.2669C53.3825 39.9245 56.8028 42.7315 59.2092 46.3329C61.6156 49.9344 62.9001 54.1685 62.9001 58.4999C62.9133 61.3796 62.3559 64.2333 61.26 66.8963C60.1641 69.5593 58.5515 71.9788 56.5152 74.0151C54.479 76.0513 52.0595 77.6639 49.3965 78.7598C46.7335 79.8557 43.8797 80.4131 41.0001 80.3999Z",
    fill: "#DB6C2F",
    stroke: "#DB6C2F",
    strokeWidth: 0.499995,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M107.7 93.2998H95.6V134.64H107.7V93.2998Z",
    fill: "#DB6C2F",
    stroke: "#DB6C2F",
    strokeWidth: 0.499995,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M136.539 28.4158L103.765 25.5483L101.667 49.5267L134.442 52.3942L136.539 28.4158Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.499995,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M41 18.8999V58.4999L27.2 95.0999",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 48.8999L41.7 59.1999",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5 21.7L41 59.2",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5 140.1H133.1",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M75.7 134.6V105.4H87.8V134.6",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M115.6 134.6V117.5H127.6V134.6",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M147.5 25.1999L135.5 24.0999L136.6 12.0999",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M100.8 57.5999L134.2 60.4999",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M100.3 63.0999L124.5 65.1999",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M105.6 44.9L114.6 37.7999L120 43.7L130.1 35.7",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M131.9 34.0999L130.8 37.0999L128.7 34.5999L131.9 34.0999Z",
    fill: "#1F323D",
    stroke: "#1F323D",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphs);
export default __webpack_public_path__ + "static/media/graphs.93c7f5bbf300dae8cdca461bb0d28043.svg";
export { ForwardRef as ReactComponent };